import { useCallback, useSyncExternalStore } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '../constants/query-keys.constants';
import type { MeResponse } from '../schemas/me.schema';

// Reads the flag from the profile the shell already fetched, without fetching it: pre-login routes have no
// profile and stay light, and logout and the 401 handler's queryClient.clear() drop it, which a disabled useQuery would not see.
export const useIsDarkModeEnabled = (): boolean | undefined => {
  const queryClient = useQueryClient();
  const subscribe = useCallback((onChange: () => void) => queryClient.getQueryCache().subscribe(onChange), [queryClient]);
  return useSyncExternalStore(subscribe, () => {
    const profile = queryClient.getQueryData<MeResponse>([QUERY_KEYS.INVESTOR_PROFILE]);
    return profile ? profile.darkModeEnabled === true : undefined;
  });
};
